import React, { useEffect } from 'react'
import { H2, Button, Paragraph, Separator, usePageWidth } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { ControlHighlight } from '@fs/zion-icon'
import { getHighlights, useSlsHighlightsContext } from '@fs/zion-sls'
import HighlightsTipsOld from '../../../../components/generic/panels/highlightPanelOld/HighlightsTipsOld'

const ReviewStep2 = ({ useTasksMethods }) => {
  const [t] = useTranslation()
  const h = useSlsHighlightsContext()
  const pageWidth = usePageWidth()
  const isSmallScreen = pageWidth({ default: true, md: false })

  const { currentTask } = useTasksMethods

  useEffect(() => {
    if (currentTask?.partitionKey) {
      const currentTaskRectFieldIds = getHighlights({ element: currentTask }).flatMap((rect) => rect.fieldId)

      h.setDisplayHighlights({
        mainPartitionKey: currentTask.partitionKey,
        mainZoomFilter: (hl) => hl.attached,
        attachFilter: (hl) => currentTaskRectFieldIds.includes(hl.fieldId) || hl.attached,
        setMainZoom: true,
        isSmallScreen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTask])

  return (
    <>
      <H2 size="H5">
        {t('full-name-correction.step2.heading', "Add or remove highlights to complete this person's full name.")}
      </H2>
      <Separator size="xs" />
      <Paragraph size="sm">
        {t(
          'full-name-correction.step2.tips-content-1',
          'Remember to include any maiden names, married names, and prefixes or suffixes, such as "Mrs.", "Mr.", and "Jr."'
        )}
      </Paragraph>
      <Paragraph size="sm">
        {t(
          'full-name-correction.step2.tips-content-2',
          "(Note: if you see a name more than once, you don't need to select it here.)"
        )}
      </Paragraph>
      <Separator size="xs" />
      <HighlightsTipsOld />
      <Separator size="xs" />
      <Button
        Icon={ControlHighlight}
        onClick={() => h.setCreatingRects(true)}
        data-testid="editHighlightTipsNewHighlightButton"
        linkName="New Highlight"
      >
        {t('editHighlight.highlightTips.newHighlight', 'New highlight')}
      </Button>
    </>
  )
}

export default ReviewStep2
